export default {
	aboutUs: "درباره‌ما",
	account: "حساب کاربری",
	action: "عملیات",
	active: "فعال",
	activity: "فعالیت",
	add: "افزودن",
	address: "آدرس",
	admin: "مدیر",
	adminPanel: "پنل مدیریت",
	admins: "مدیران",
	all: "همه",
	amount: "مبلغ",
	answer: "پاسخ",
	app: "اپلیکیشن",
	arithmetic: "حساب",
	hasVideo: "ویدیو دارد",
	backHome: "بازگشت به صفحه اصلی",
	banner: "بنر",
	basic: "پایه",
	birthdate: "تاریخ تولد",
	blocked: "مسدود",
	business: "کسب و کار",
	buy: "خرید",
	byOwner: "توسط شرکت هومان",
	cancel: "لغو",
	category: "دسته‌بندی",
	categories: "دسته‌بندی‌ها",
	change: "تغییر",
	choose: "انتخاب کنید",
	city: "شهر",
	close: "بسته",
	code: "کد",
	color: "رنگ",
	comingSoon: "بزودی",
	comma: "،",
	company: "شرکت",
	comparePass: "تکرار کلمه عبور صحیح وارد نشده است",
	confirm: "تایید",
	contactUs: "تماس‌با‌ما",
	content: "محتوا",
	copyright: "تمامی حقوق این سایت متعلق به {0} می‌باشد.",
	cost: "هزینه",
	count: "تعداد",
	couponGuide:
		"در صورت استفاده از کد تخفیف بر روی یک دوره تخفیف دار، درصد تخفیف بر روی قیمت دوره بعد از تخفیف اعمال میشود!",
	cover: "کاور",
	countDown: "شمارش معکوس",
	course: "دوره",
	create: "ساخت",
	credit: "اعتبار",
	cut: "برش",
	currency: "واحد پول",
	current: "فعلی",
	dark: "تاریک",
	dashboard: "داشبورد",
	date: "تاریخ",
	default: "پیش‌فرض",
	description: "توضیحات",
	discount: "تخفیف",
	draft: "پیش‌نویس",
	duration: "مدت زمان",
	edit: "ویرایش",
	default: "پیش فرض",
	delete: "حذف",
	deleteConfirm: "از حذف این آیتم اطمینان دارید؟",
	device: "دستگاه",
	do: "کنید",
	education: "تحصیلات",
	educate: "آموزش",
	eitaa: "ایتا",
	else: "غیر",
	email: "ایمیل",
	enter: "ورود",
	error: "خطا",
	expire: "انقضا",
	expired: "منقضی",
	extension: "پسوند",
	faq: "سوالات متداول",
	fax: "فکس",
	features: "امکانات",
	financial: "مالی",
	file: "فایل",
	force: "اجبار",
	forgotPassword: "رمز عبور خود را فراموش کردید؟",
	forum: "انجمن",
	gateway: "درگاه پرداخت",
	gender: "جنسیت",
	getOtp: "دریافت رمز یکبار مصرف",
	group: "گروه",
	gift: "هدیه",
	ha: "‌ها",
	harvest: "برداشت",
	homePage: "صفحه‌اصلی",
	icon: "آیکن",
	igap: "آیگپ",
	image: "تصویر",
	imperfect: "ناقص",
	in: "در",
	inactive: "غیر فعال",
	income: "درآمد",
	info: "اطلاعات",
	ingredients: "لوازم مورد نیاز",
	intro: "اینترو",
	instagram: "اینستاگرام",
	invisible: "غیر قابل مشاهده",
	last: "آخرین",
	lastName: "نام خانوادگی",
	latitude: "عرض جغرافیایی",
	light: "روشن",
	link: "لینک",
	list: "لیست",
	login: "ورود",
	logo: "لوگو",
	logout: "خروج",
	longitude: "طول جغرافیایی",
	managment: "مدیریت",
	manual: "دستی",
	members: "اعضا",
	message: "پیام",
	minute: "دقیقه",
	mobile: "موبایل",
	month: "ماه",
	multiple: "چندگانه",
	name: "نام",
	nationalCode: "کد ملی",
	new: "جدید",
	normal: "معمولی",
	not: "غیر",
	notfound: "متأسفیم، چنین صفحه‌ای وجود ندارد.",
	notification: "اعلان",
	notifications: "اعلانات",
	number: "عدد",
	open: "باز",
	os: "سیستم عامل",
	owner: "مالک",
	package: "پکیج",
	pages: "صفحات",
	paid: "پرداخت شده",
	password: "کلمه عبور",
	passwordRecovery: "بازیابی کلمه عبور",
	pending: "معلق",
	permission: "سطح دسترسی",
	permissions: "سطوح دسترسی",
	percent: "درصد",
	person: "نفر",
	personal: "شخصی",
	phone: "تلفن",
	plan: "پلن",
	plans: "پلن‌ها",
	platform: "پلتفرم",
	post: "مطلب",
	posts: "مطالب",
	price: "قیمت",
	pricing: "قیمت گذاری",
	primitive: "اولیه",
	profile: "پروفایل",
	province: "استان",
	public: "عمومی",
	publish: "انتشار",
	published: "منتشر شده",
	question: "سوال",
	qty: "تعداد",
	ratio: "نسبت",
	record: "ثبت",
	region: "منطقه",
	register: "ثبت نام",
	rejected: "رد شده",
	rejectionReason: "دلیل رد",
	repeat: "تکرار",
	resend: "ارسال مجدد",
	rial: "ریال",
	role: "نقش",
	roles: "نقش‌ها",
	row: "ردیف",
	request: "درخواست",
	sample: "نمونه کار",
	score: "امتیاز",
	scores: "امتیازات",
	search: "جستجو",
	section: "بخش",
	serial: "سریال",
	session: "جلسه",
	sessions: "جلسات",
	settings: "تنظیمات",
	shaba: "شبا",
	share: "اشتراک گذاری",
	show: "نمایش",
	sms: "پیامک",
	sort: "مرتب سازی",
	soroush: "سروش",
	special: "ویژه",
	status: "وضعیت",
	statusConfirm: "از تغییر وضعیت این آیتم اطمینان دارید؟",
	submit: "ارسال",
	subscription: "اشتراک",
	summary: "خلاصه",
	subject: "موضوع",
	subscription: "اشتراک",
	success: "موفق",
	successfully: "موفقیت آمیز",
	suspend: "معلق",
	symbol: "نماد",
	systematic: "سیستمی",
	tac: "قوانین و مقررات",
	tag: "برچسب",
	tags: "برچسب‌ها",
	telegram: "تلگرام",
	text: "متن",
	theme: "تم",
	time: "زمان",
	title: "عنوان",
	to: "به",
	today: "امروز",
	toman: "تومان",
	total: "مجموع",
	training: "آموزش",
	transaction: "تراکنش",
	type: "نوع",
	unauthorized: "متأسفیم، شما به این صفحه دسترسی ندارید.",
	unlimited: "نامحدود",
	unpaid: "پرداخت نشده",
	unpublished: "منتشر نشده",
	unsuccess: "ناموفق",
	update: "بروزرسانی",
	upload: "بارگذاری",
	usable: "قابل استفاده",
	user: "کاربر",
	username: "نام کاربری",
	users: "کاربران",
	value: "مقدار",
	version: "ورژن",
	video: "ویدیو",
	visible: "قابل مشاهده",
	visit: "بازدید",
	warning: "هشدار",
	website: "سایت",
	whatsapp: "واتس‌اپ",
	webDesign: "طراحی سایت",
	with: "با",
	workTime: "زمان کاری",
	y: "ی",
	yes: "بله",
	no: "ندارد",
	uploadErros: {
		size: "حجم فایل باید کمتر از 10 مگ باشد",
		sizePdf: "حجم فایل باید کمتر از 5 مگ باشد",
		sizeVideo: "حجم فایل باید کمتر از 500 مگ باشد",
		extension: "فرمت فایل معتبر نمی‌باشد",
		extensionFile: "فرمت فایل باید یکی از فرمت های ogg,mp3,pdf باشد.",
	},
};
